/* Overrides for react-phone-number-input's default focus styling so that
   focusing / switching the country flag doesn't render a blue focus ring. */

/* Neutralize the library's focus accent color. `currentColor` still resolved
   to (near-black) document text, which was invisible on the dark theme but
   showed as a ring in light mode — use a fully transparent focus color so the
   ring is gone in both themes. */
:root {
  --PhoneInput-color--focus: transparent;
}

/* Kill the browser focus ring on the (invisible) country <select> and any
   library box-shadow it triggers. */
.PhoneInputCountrySelect:focus,
.PhoneInputCountrySelect:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

/* Belt-and-suspenders: remove focus outlines from the country container and
   its children (the select overlays the whole flag box). */
.PhoneInputCountry:focus-within,
.PhoneInputCountry :focus,
.PhoneInputCountry :focus-visible {
  outline: none !important;
}

/* Remove the outline the library permanently draws around the flag image
   (a box-shadow "border" on the flag icon), in every state. */
.PhoneInputCountryIcon,
.PhoneInputCountryIcon--border,
.PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {
  box-shadow: none !important;
  background-color: transparent !important;
}
